enum ItemListOrderByFilter {
  SaleEndingSoon = 'SaleEndingSoon',
  RecentlyCreated = 'RecentlyCreated',
  RecentlyListed = 'RecentlyListed',
  Cheapest = 'Cheapest',
  Expensive = 'Expensive',
}

export default ItemListOrderByFilter;
